import { userService } from '../../_services';
import router from '../../router/index'

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null };

export const authentication = {
    namespaced: true,
    state: initialState,
    getters: {

    },
    actions: {
        login({ dispatch, commit }, data) {
            commit('loginRequest', data);
            userService.login(data)
                .then(
                    user => {
                        commit('loginSuccess', user);
                        router.push('/');
                    },
                    error => {
                        commit('loginFailure', error);
                        dispatch('alert/error', error, { root: true });
                    }
                );
        },
        registration({ dispatch }, data) {
            userService.registration(data)
                .then(
                    () => {
                        router.push('/authentication/login');
                    },
                    error => {
                        dispatch('alert/error', error, { root: true });
                    }
                );
        },
        getUser({ commit }) {
            userService.getUser()
                .then(
                    user => {
                        commit('loginSuccess', user);
                    },
                    error => {
                        console.log(error)
                        router.push('/authentication/login');
                    }
                );
        },
        logout({ commit }) {
            userService.logout()
                .then(
                    () => {
                        commit('logout');
                        router.push('/authentication/login');
                    }
                );
        }
    },
    mutations: {
        loginRequest(state, user) {
            state.status = { loggingIn: true };
            state.user = user;
        },
        loginSuccess(state, user) {
            state.status = { loggedIn: true };
            state.user = user;
        },
        loginFailure(state) {
            state.status = {};
            state.user = null;
        },
        logout(state) {
            state.status = {};
            state.user = null;
        }
    }
}